import { get } from 'lodash';
export const namespace = 'geoSelector';

export const ActionType = {
  GET_SEARCH_DATA: 'geoFencing/GET_SEARCH_DATA',
  LOAD_SUB_REGION: 'geoFencing/LOAD_SUB_REGION',
  LOAD_SAVED_LOCATIONS: `${namespace}/LOAD_SAVED_LOCATIONS`,
  SET_SELECTION: 'geoFencing/SET_SELECTION',
  SET_REGION_DATA: 'geoFencing/SET_REGION_DATA',
  SET_SEARCH_RESULT: 'geoFencing/SET_SEARCH_RESULT',
  UPDATE_GEO_SELECTED: "geoFencing/UPDATE_GEO_SELECTED",
  UPDATE_COUNTRY_LOADED_STATUS: "geoFencing/UPDATE_COUNTRY_LOADED_STATUS",
  LOAD_UNRATED_MARKET: 'geoFencing/LOAD_UNRATED_MARKET',
  SET_UNRATED_MARKET: 'geoFencing/SET_UNRATED_MARKET'
};

export const Status = {
  STATUS_INITIAL: 'initial',
  STATUS_LOADING: 'loading',
  STATUS_LOADED: 'loaded',
  STATUS_ERROR: 'error'
};

export const FetchResult = {
  FETCH_SUCCESS: 'SUCCESS'
};

export const REGION_WORLD = 'world';

export const clearSelection = () => ({
  payload: {
    selectedIds: [],
    includeUnidentifiedLocation: false
  },
  type: ActionType.SET_SELECTION
});

export const getSearchData = (searchValue) => {
  return (dispatch) => {
    dispatch({
      type: ActionType.GET_SEARCH_DATA,
      payload: {
        searchValue
      }
    })
  }
};

export const loadSubRegion = (regionInfo) => {
  return (dispatch) => {
    dispatch({
      payload: regionInfo,
      type: ActionType.LOAD_SUB_REGION
    })
  }
};

export const loadSavedLocations = (selectedIds, selectionType) => {
  return (dispatch) => {
    dispatch({
      type: ActionType.LOAD_SAVED_LOCATIONS,
      payload: {
        selectedIds,
        selectionType
      }
    })
  }
};

export const setSelection = (selectionData) => {
  return (dispatch) => {
    dispatch({
      payload: selectionData,
      type: ActionType.SET_SELECTION
    })
  }
};

export const setRegionData = (regionData) => {
  return (dispatch) => {
    dispatch({
      payload: regionData,
      type: ActionType.SET_REGION_DATA
    })
  }
};

export const setSearchResult = (searchResult) => {
  return (dispatch) => {
    dispatch({
      type: ActionType.SET_SEARCH_RESULT,
      payload: {
        searchResult
      }
    })
  }
};

export const updateGeoSelected = (geoSelected, geoIndeterminate) => {
  return (dispatch) => {
    dispatch({
      type: ActionType.UPDATE_GEO_SELECTED,
      payload: {
        geoSelected,
        geoIndeterminate
      }
    })
  }
}

export const updateCountryLoadedStatus = status => {
  return (dispatch) => {
    dispatch({
      type: ActionType.UPDATE_COUNTRY_LOADED_STATUS,
      payload: {
        status
      }
    })
  }
};

export const preloadUnratedMarket = () => {
  return (dispatch) => {
    dispatch({
      type: ActionType.LOAD_UNRATED_MARKET
    })
  }
};

export const setUnratedMarket = (unratedIds) => {
  return (dispatch) => {
    dispatch({
      payload: {
        unratedIds
      },
      type: ActionType.SET_UNRATED_MARKET
    })
  }
};

export const selectGeoFencing = state => state[namespace];
export const selectGeoSelected = state => selectGeoFencing(state).geoSelected;
export const selectLocationDetail = (id, level) => state => {
  return get(selectGeoFencing(state), [`locationLevel${level}`, id]);
};
